
import styles from './mainSection.module.css';
import { MarkupLayout } from '../../ui/markupLayout/MarkupLayout';
import { AdvantagesSection } from './advantagesSection/AdvantagesSection';
import { CompanyHistorySection } from './companyHistorySection/CompanyHistorySection';
import { AchievementsSection } from './achievementsSection/AchievementsSection';

export function MainSection() {
  return (
    <MarkupLayout>
      <section className={styles.mainContainer}>
        <AdvantagesSection />
        <CompanyHistorySection />
        {/* <AchievementsSection /> */}
      </section>
    </MarkupLayout>
  );
}
